/**
 * SiteAlert
 */

import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import Link from 'components/Link';
import Responsive from 'components/Responsive';

import styles from './styles.css';

const SiteAlert = ({
	className,
	link,
	title,
	titleLong
}) => {
	if (!title) {
		return null;
	}

	const alertElement = (
		<div className={ styles.container }>
			<div className={ styles.title }>{ title }</div>
			<div className={ classNames(styles.title, styles.titleLong) }>{ titleLong || title }</div>
		</div>
	);

	return (
		<div data-wrapper className={ classNames(className, styles.alert) }>
			<Responsive className={ styles.responsive }>
				{ link
					? <Link to={ link }>{ alertElement }</Link>
					: alertElement
				}
			</Responsive>
		</div>
	);
};

SiteAlert.propTypes = {
	title: PropTypes.string,
	titleLong: PropTypes.string,
	className: PropTypes.string,
	link: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};

SiteAlert.defaultProps = {
	title: null,
	titleLong: null,
	className: null,
	link: null
};

export default SiteAlert;
